import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./pages/home/home.component";
import { LoginComponent } from "./pages/login/login.component";
import { AuthGuard } from "./pages/auth/auth.guard";
import { AdminComponent } from "./pages/admin/admin.component";
import { OutofofficeComponent } from "./pages/outofoffice/outofoffice.component";
import { DashboardContainerComponent } from "./pages/outofoffice/dashboard-container.component";
import { PersonalDesktopComponent } from "./pages/outofoffice/personal-desktop.component";
import { ManagementDesktopComponent } from "./pages/outofoffice/management-desktop.component";
import { DelegationComponent } from "./pages/delegation/delegation.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { ApprovalTrackComponent } from "./pages/approvaltrack/approvaltrack.component";
import { DocumentComponent } from "./pages/document/document.component";
import { InandoutComponent } from "./pages/inandout/inandout.component";
import { MailApproveComponent } from "./pages/mail-approve/mail-approve.component";
import { ShiftSchedulerComponent } from "./pages/shift/shift-scheduler.component";
import { MonthlyCalcComponent } from "./pages/monthly-calc/monthly-calc.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";

const routes: Routes = [
  { path: "", component: LoginComponent, canActivate: [AuthGuard] },

  { path: "home", component: HomeComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent },
  {
    path: "forgot",
    component: ForgotPasswordComponent,
  },
  { path: "reset", component: ResetPasswordComponent },

  { path: "admin", component: AdminComponent, canActivate: [AuthGuard] },
  // {
  //   path: "outofoffice",
  //   component: OutofofficeComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: "main",
    component: DashboardContainerComponent,
    children: [
      {
        path: "summary",
        component: PersonalDesktopComponent,
        data: { title: "Personel Özet Ekranı", minRole: "PERSONNEL" },
        canActivate: [AuthGuard],
      },
      {
        path: "approve",
        component: OutofofficeComponent,
        data: { title: "Yönetici Onay Merkezi", minRole: "MANAGER" },
        canActivate: [AuthGuard],
      },
      {
        path: "shift",
        component: ShiftSchedulerComponent,
        data: { title: "Vardiya", minRole: "MANAGER" },
        canActivate: [AuthGuard],
      },
      {
        path: "inandout",
        component: InandoutComponent,
        data: { title: "Hareketler", minRole: "MANAGER" },
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
  },
  // {
  //   path: "shift",
  //   component: ShiftSchedulerComponent,
  //   canActivate: [AuthGuard],
  // },
  { path: "monthly-calc", component: MonthlyCalcComponent },

  {
    path: "delegation",
    component: DelegationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "approvaltrack",
    component: ApprovalTrackComponent,
    canActivate: [AuthGuard],
  },
  { path: "document", component: DocumentComponent, canActivate: [AuthGuard] },
  // { path: "inandout", component: InandoutComponent, canActivate: [AuthGuard] },
  { path: "mail-approve", component: MailApproveComponent },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  ngOnInit() {}
}
